import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  //  顶级路由
  {
    path: '/',
    redirect: '/about'
  },
  {
    path: "/about",
    component: () => import('@/views/About.vue'),
    redirect: "/home",
    children: [
      {
        path: "/home",
        component: () => import('@/views/Home.vue')
      },
      {
        path: "/equipment",
        component: () => import('@/views/Equipment.vue')
      }, {
        path: "/production",
        component: () => import('@/views/Production.vue')
      }, {
        path: "/personnel",
        component: () => import('@/views/Personnel.vue')
      },
      {
        path: "/split",
        component: () => import('@/views/Split.vue')
      }


    ]
  },
 
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
